/*Konva.Layer.prototype._setSmoothEnabled = function() {
    this.getContext()._context.imageSmoothingEnabled = this.imageSmoothingEnabled();
    if (this.getAttr("imageSmoothingQuality")) {
        this.getContext()._context.imageSmoothingQuality = this.getAttr("imageSmoothingQuality");
    }
        
};*/
import {KonvaComponentBase} from './KonvaComponentBase.mjs';
import {Util} from './Util.mjs';
import {TAGS, MODE, IconsRepository} from "./GlobalStatics.mjs";
import {PredefinedPresenters} from "./PredefinedPresenters.ts";
import {ScaleTransformer} from "./ScaleTransformer.mjs";
import {KonvaComponentPhotoLoadQueue} from "./TaskQueue.mjs";
import {AlertBadge} from "./AlertBadge.mjs";
import {CustomFilters} from "./CustomFilters.mjs";
import {KonvaCropper} from "./KonvaCropper.mjs";
import {Photo} from "./Photo.mjs";

export class KonvaComponent extends KonvaComponentBase {

    //#region Own properties
    /**
     * Referencja do aktualnie załadowanego layout'u
     * @private
     * @type {Konva.Group}
     */
    layout;

    /**
     * Skala layout'u względem mainLayer
     * @private
     * @type {Number}
     */
    layoutScale = 1;

    /**
     * Referencja do transformera
     * @private
     * @type {ScaleTransformer}
     */
    transformer;

    /**
     * @private
     * @type {ClientSelector}
     * 
    clientSelector;  tymczasowo wycofany   */

    /**
     * Szerokość kartki w pixelach
     * @private
     * @type {Number}
     */
    pageWidth;

    /**
     * Wysokość kartki w pixelach
     * @private
     * @type {Number}     
     */
    pageHeight;

    /**
     * Przelicznik z mm na px
     * @private
     * @type {Number}
     */
    pageUnit = 10; // 1 mm = 10 px

    /**
     * Progi dpi
     * @private
     * @type {Number}
     */
    MinimumDpi = 150;
    OptimalDpi = 300;

    /**
     * Aktualny tryb pracy komponentu
     * @private
     * @type {MODE}
     */
    mode;

    /**
    * @private
    * @type {AbortController}
    * AbortController - służy do anulowania akcji, po wywołaniu dispose
    *
    */
    abortController;


    /**
    * @private
    * @type {Set<void>}
    * Lista sygnałów anulwoania wczytywania zdjęć
    * 
    */
    abortHandlers;

    /**
    * @private
    * @type {string}
    * Podstawowe teksty
    */
    lowQualityMessage;
    mediumQualityMessage;

    /**
     * Lokalne repozytorium <img> załadowanych ikon
     * @private
     * @type {IconsRepository}
     */
    ICONS_REPOSITORY;

    /**
    * @private
    * @type {Konva.Shape}
    * Zaznaczony obiekt - odpowiednik clientSelector
    */
    selectedItem = null;

    minRequestedImagesLongerSide = 0; //domyślnie

    /**
     * Maksymalna długość boku zdjęcia, które może być zażądane przez komponent 
     * (domyśla wartość odnosi się do trybu klienta - do renderu ustawić na null)
     * @private
     * @default 2048
     * @type {number}
     */
    maxRequestedImagesLongerSide = 2048;

    /**
     * Device pixel ratio - na użądzeniach mobilnych pixele są bardziej zagęszczone - potrzebne do obliczania potrzebnej wielkości zdjęcia
     * @private
     * @type {number}
     */
    pixelRatio;

    /**
     * Czy przeglądarka obsługuje filtry w 2dContext - np. IOS nie obsługuje
     * @type {boolean}
     */
    contextFilterAvailable;

    /**
     * @private
     * Timeout do ponownego wczytania zdjęcia
     */
    requestReloadTimeout = null;

    /**
     * @private
     * Czy layout posiada już wczytane zdjęcia
     */
    containsLoadedPhotos = false;

    /**
     * Liczba placeholderów zdjęć w layoutcie
     * @private
     * @type {number}
     */
    photoPlaceholdersCount = 0;

    /**
     * @private
     * Czy layout jest wyświetlany na urządzeniu mobilnym (brak obsługi moseover)
     */
    isMobile = false;

    /**
     * @private
     * Pomocnicza zmienna przechowująca startową pozycję dotyku - potrzebne do właściwego działania scroll na telefonach
     */
    _touchStartPosition = null;
    // #endregion

    // #region Object maintenance
    /**
     * @param {DotNetObjectReference} dotNetReference
     * @param {Uid} domElementUid
     * @param {boolean} isMobile
     * @param {boolean} addReasizeEventListener
     * @param {string} textItemsPromptText
     * @param {string} lowQualityPhotoMessage
     * @param {string} mediumQualityPhotoMessage
     */
    constructor(dotNetReference, domElementUid, isMobile, addReasizeEventListener = true, textItemsPromptText, lowQualityPhotoMessage, mediumQualityPhotoMessage) {
        super(dotNetReference, domElementUid, textItemsPromptText); // wywołanie konstruktora bazowego
        this.isMobile = isMobile; // czy layout jest wyświetlany na urządzeniu mobilnym (brak obsługi mouseover)
        this.contextFilterAvailable = Util.supportsContextFilters();
        this.lowQualityMessage = lowQualityPhotoMessage || "Low quality";
        this.mediumQualityMessage = mediumQualityPhotoMessage || "Medium quality";
        this.pixelRatio = window.devicePixelRatio || 1; // ustawienie domyślnego pixel ratio, jeśli nie jest dostępne to 1
        if (addReasizeEventListener === true) {
            this.resizeFunRef = this.resizeStage.bind(this);
            window.addEventListener('resize', this.resizeFunRef);

        }
        this.abortController = new AbortController();
        this.abortHandlers = new Set();

        this.abortController.signal.onabort = () => {
            this.abortHandlers.forEach(handler => handler());
            this.abortHandlers.clear();
        };
        this.ICONS_REPOSITORY = new IconsRepository(this.abortHandlers); // inicjalizacja repozytorium ikon
    }

    /**
     * Metoda usuwająca obiekt KonvaComponent
     */
    dispose() {
        super.dispose(); // wywołanie dispose z klasy bazowej
        this.abortController.abort();
        this.layout = null;
        this.layoutScale = 1;
        this.containsLoadedPhotos = false;
        this.photoPlaceholdersCount = 0;
    }

    // #endregion

    // #region Event handlers
    /**
     * Metoda obsługująca kliknięcia w trybie projektowania
     * @param {Konva.Shape} target
     */
    handleClickDesignMode = ({ target }) => {
        // if click on empty area - remove all selections
        if (target === this.stage || target.hasName('background')) {
            this.transformer.diselectItem();
            //jsDotNetCommunication.sedAllItemsDiselected();
        }

        // Jeśli kliknięty element ma rodzica (group) o name='textboxGroup'
        if (target.hasName(TAGS.TEXTBOX)) {
            target = target.getParent();
        } else if (!target.hasName("shape") && !target.hasName(TAGS.IMAGE_PLACEHOLDER) && !target.hasName(TAGS.IMAGE_RESOURCE))
            return;

        this.transformer.selectItem(target);
        //sendItemSelected(target);
    }

    /**
     * Metoda obsługująca kliknięcia w trybie klinenta
     * @param {Konva.Shape} target
     */
    handleClickClientMode = ({ target }) => {

        if (!target.hasName(TAGS.IMAGE_PLACEHOLDER) && !target.hasName(TAGS.TEXTBOX)) {
            //this.clientSelector.clearSelection();
            this.selectedItem = null;
            this.sendItemsDeselected();
            return;
        }

        //this.clientSelector.makeSelection(target);
        this.selectedItem = target;
        this.sendItemSelected(target);

    }

    //#region Custom touch handlers - potrzebne do scroll na urządzeniach mobilnych
    /**
     * Metoda rejestruje początek dotyku
     */
    handleTouchStart = (e) => {
        // Ustawienie początkowej pozycji z pierwszego dotyku
        const touch = e.evt.touches[0];
        this._touchStartPosition = {
            x: touch.clientX,
            y: touch.clientY
        };
    }

    /**
     * Metoda rejestruje zakończenie dotyku i sprawdza, czy to był klik.
     * Jeliś, tak, to wywołuje funckję obsługującą kliknięcie.
     */
    handleTouchEnd = (e) => {
        // Pobranie pozycji końcowej ze zdarzenia touchend
        const touch = e.evt.changedTouches[0];
        const touchEndPosition = {
            x: touch.clientX,
            y: touch.clientY
        };

        // Sprawdzenie odległości pomiędzy punktem startowym a końcowym
        const dx = touchEndPosition.x - (this._touchStartPosition ? this._touchStartPosition.x : 0);
        const dy = touchEndPosition.y - (this._touchStartPosition ? this._touchStartPosition.y : 0);
        const distance = Math.sqrt(dx * dx + dy * dy);

        // Warunek: gdy przesunięcie jest mniejsze niż 10 pikseli, wywołaj funkcję handleClickClientMode
        if (distance < 10) {
            // Wywołanie funkcji handleClickClientMode z obiektem zawierającym oryginalny target eventu
            this.clickFunRef({ target: e.target });
        }
    }
    //#endregion

    //#endregion

    //#region Mode handlers
    modeHandler(mode) {
        if (this.mode === mode) return; // jeśli tryb się nie zmienił to nie trzeba nic robić
        this.mode = mode; // ustawienie trybu

        // usunięcie podpięć --> zmiana trybu wiąże się ze zmianą referencji do funkcji obsługi kliknięcia, więc trzeba usunąć poprzednie podpięcia zdarzeń
        if (this.isMobile) {
            this.stage.off('touchstart', this.handleTouchStart);
            this.stage.off('touchend', this.handleTouchEnd);
        } else {
            this.stage.off('click', this.clickFunRef);
        }

        if (mode === MODE.PREVIEW || mode === MODE.RENDER) // w trybie Preview i Render nie ma obsługi kliknięć
        {
            this.stage.listening(false); // wyłączenie nasłuchiwania na kliknięcia w trybie Preview i Render
            this.clickFunRef = null; // ustawienie funkcji obsługi kliknięcia na null, bo nie jest potrzebna
            this.transformer.diselectItem();
            this.transformer.remove();
            //this.mainLayer.remove(this.clientSelector);
            return; // nie ma potrzeby wykonywania dalszych działań w trybie Preview i Render
        }

        this.stage.listening(true);

        if (mode === MODE.CLIENT) //switch to client mode
        {
            this.clickFunRef = this.handleClickClientMode; // ustawienie nowej funkcji obsługi kliknięcia
            this.transformer.diselectItem();
            this.transformer.remove();
            //this.mainLayer.add(this.clientSelector);
        }
        else if (mode === MODE.DESIGN) {
            this.clickFunRef = this.handleClickDesignMode;
            this.selectedItem = null;
            this.mainLayer.add(this.transformer);

        }
        this.attachItemsStyleReactions(mode); // podpięcie reakcji na style placeholderów i textboxów w zależności od trybu
        // podpięcie zdarzeń z nową referencją do funkcji obsługi kliknięcia
        if (this.isMobile) {
            this.stage.on('touchstart', this.handleTouchStart);
            this.stage.on('touchend', this.handleTouchEnd);

        } else {
            this.stage.on('click', this.clickFunRef);
        }

    }

    /**
     * Metoda podpina rekacje na mouseover i mouseout dla placeholderów zdjęć i textboxów (tylko na komputerach)
     * @param {MODE} mode
     */
    attachItemsStyleReactions(mode) {
        if (this.isMobile) return; // na urządzeniach mobilnych nie ma obsługi mouseover i mouseout
        if (mode === MODE.CLIENT) {
            for (const node of this.mainLayer.find(`.${TAGS.IMAGE_PLACEHOLDER}`)) {
                node.on('mouseover', this.onMouseOverPlaceholderStyleReaction);
                node.on('mouseout', this.onMouseOutPlaceholderStyleReaction);
            }
            for (const text of this.mainLayer.find(`.${TAGS.TEXTBOX}`)) {
                text.on('mouseover', this.onMouseOverTextboxStyleReaction);
                text.on('mouseout', this.onMouseOutTextboxStyleReaction);
            };
        }
        else if (mode === MODE.DESIGN) {
            for (const node of this.mainLayer.find(`.${TAGS.IMAGE_PLACEHOLDER}`)) {
                node.off('mouseover', this.onMouseOverPlaceholderStyleReaction);
                node.off('mouseout', this.onMouseOutPlaceholderStyleReaction);
            }
            for (const text of this.mainLayer.find(`.${TAGS.TEXTBOX}`)) {
                text.off('mouseover', this.onMouseOverTextboxStyleReaction);
                text.off('mouseout', this.onMouseOutTextboxStyleReaction);
            };
        } 
    }
    //#endregion
    
    //#region Inicjalizacja layout'u
    /**
     * Funkcja tworzy nowy template i zwraca status jego utworzenia. Automatycznie ustawiany jest tryb design.
     * @public
     * @param {number} width - szerokość strony w mm
     * @param {number} height - wysokość strony w mm
     * @returns {boolean}
     */
    async initCreate(width, height) {
        this.pageUnit = Math.max(width, height) > 500 ? 1 : 10;
        this.pageWidth = width * this.pageUnit;  // warto w tym miejscu adaptować pageUnit tak aby odciążyć skalę stage
        this.pageHeight = height * this.pageUnit;
        this.createNewMainLayer();
        this.loadBackground("white", null);
        this.layout = new Konva.Group({ id: TAGS.LAYOUT, designWidth: this.pageWidth, designHeight: this.pageHeight });
        this.mainLayer.add(this.layout);
        const { presenterLayer, offset, size } = await this.getPresenterLayer("Page", null);
        const stageConfig = {
            offset: offset,
            width: (this.pageWidth + (-2) * offset.x), //offset jest na minusie!
            height: (this.pageHeight + (-2) * offset.y)
        }
        this.createNewStage(stageConfig);
        this.stage.add(this.mainLayer);
        this.stage.add(presenterLayer); 
        this.resizeStage();
        this._initBase(MODE.DESIGN);
        return true;
    }

    /**
     * Funkcja "zpieka template" na podstawie parametrów z jsona. Zwraca status.
     * @public
     * @param {MODE} mode - tryb pracy komponentu 
     * @param {string} templateCreationParamsJson - json z parametrami tworzenia szablonu
     * @returns {boolean}
     */
    async initLoad_Bake(templateCreationParamsJson, mode) {
        if (!templateCreationParamsJson) return false; // jeśli json jest pusty to nie trzeba nawet próbować zakłądać stage
        let templateCreationParams; // obiekt z parametrami tworzenia szablonu
        this.containsLoadedPhotos = false;
        this.photoPlaceholdersCount = 0; // resetujemy liczbę placeholderów zdjęć w layoutcie

        //#region 1 - Pobrać parametry tworzenia szablonu i zdeserializować jsona
        try {
            templateCreationParams = JSON.parse(templateCreationParamsJson);
            this.pageUnit = Math.max(templateCreationParams.Size.Width, templateCreationParams.Size.Height) > 500 ? 1 : 10; // warto w tym miejscu adaptować pageUnit tak, aby odciążyć skalę stage
            this.pageWidth = templateCreationParams.Size.Width * this.pageUnit;
            this.pageHeight = templateCreationParams.Size.Height * this.pageUnit;

            if (templateCreationParams.QualityLevels) {
                this.MinimumDpi = templateCreationParams.QualityLevels.MinimalDpi;
                this.OptimalDpi = templateCreationParams.QualityLevels.OptimalDpi;
            }
        } catch (e) {
            console.error("Invalid creation params - ", e);
            return false;
        }
        //#endregion

        //#region 2 - Przygotować warstwy i wyliczyć "wirtualnie"" rozmiar stage
        const { presenterLayer, offset, size } = await this.getPresenterLayer(templateCreationParams.PresenterType, templateCreationParams.PresenterCustomJson);
        if (!presenterLayer || !offset) {
            console.error("Error while getting presenter");
            return false;
        }
        const stageAbsW = size.width || this.pageWidth + (-2) * offset.x; //offset jest na minusie!
        const stageAbsH = size.height || this.pageHeight + (-2) * offset.y;
        
        const { scale: stageScale, ...position } = Util.getCentralFitInParams(
            stageAbsW,
            stageAbsH,
            document.getElementById(this.domElementUid).clientWidth,
            document.getElementById(this.domElementUid).clientHeight);

        this.pageScale = stageScale;

        if (!this.mainLayer)
            this.createNewMainLayer();

        this.mainLayer.clip({
            x: 0,
            y: 0,
            width: this.pageWidth,
            height: this.pageHeight
        });

        this.loadBackground(templateCreationParams.BackgroundColor, templateCreationParams.BackgroundImageId);
        this._loadLayout(templateCreationParams.LayoutJson, true, templateCreationParams.Resizable);
        //#endregion

        //#region 3 - Stworzenie stage i dodanie warstw
        const stageConfig = {
            offset: offset,
            width: stageAbsW * stageScale, 
            height: stageAbsH * stageScale,
            scale: { x: stageScale, y: stageScale }
        }

        if (!this.stage) {
            this.createNewStage(stageConfig);
        } else {
            this.stage.setAttrs({
                nativePageUnit: this.pageUnit,
                ...stageConfig
            });
        }
        this.stage.add(this.mainLayer);
        this.stage.add(presenterLayer);
        //#endregion


        this._initBase(mode);
        //this.resizeStage();
        this.stage.batchDraw();
        return true; // load zakończony sukcesem
    }

    /**
     * Funkcja ładująca template ("zpieczony") z jsona - wtórnie lub pierwszy raz. Zrewtaca status.
     * @public
     * @param {string} json - zserializowany template (stage)
     * @param {MODE} mode - tryb pracy komponentu
     * @param {string} qualityLevels - zserializowane progi jakości zdjęć
     * @returns {boolean}
     */
    initLoad(json, mode, qualityLevels) {

        if (!json) return false; // jeśli json jest pusty to nie trzeba nawet próbować zakłądać stage
        let newStage;
        try {
            newStage = Konva.Node.create(json, this.domElementUid); // "Próbne" stworzenie stage na podstawie jsona --> można rozważyć robienei prób na offcanvas
        } catch (e) {
            console.log("Error during Konva.Node.create: " + e);
            return false;
        }
        if (!newStage) return false; // nie udało się stworzyć stage na podstawie jsona

        if (this.stage) { // jeśli już istnieje stage to trzeba go zniszczyć i wyczyścić parametry
            this.stage.destroy();
            this.stage = null;
            this.mainLayer = null;
            this.pageScale = 1;
            this.layout = null;
            this.layoutScale = 1;
            this.containsLoadedPhotos = false;
            this.photoPlaceholdersCount = 0;
        }
            

        this.stage = newStage;

        const pageMainBackground = this.stage.findOne(`#${TAGS.PAGE_MAIN_BACKGROUND}`);
        if (!pageMainBackground) {
            console.log("Error: pageMainBackground not found in the stage.");
            return false; // nie udało się znaleźć tła - corrupted Layout
        }

        if (this.isMobile) {
            pageMainBackground.preventDefault(false);
        }

        this.pageUnit = this.stage.getAttr('nativePageUnit') || this.pageUnit; // jeśli nie podano to domyślnie 10px/mm
        this.pageWidth = pageMainBackground.width();
        this.pageHeight = pageMainBackground.height();
        this.pageScale = this.stage.scaleX();

        this.mainLayer = this.stage.findOne(`#${TAGS.MAIN_LAYER}`);
        if (!this.mainLayer) {
            console.error("Error: mainLayer not found in the stage.");
            return false;
        }

        this.layout = this.mainLayer.findOne(`#${TAGS.LAYOUT}`);
        if (!this.layout) {
            console.error("Error: layout not found in the stage.");
            return false; // corrupted Layout
        }
        this.layoutScale = this.layout.scaleX();
        this.containsLoadedPhotos = false; // resetujemy flagę, bo może być ustawiona na true z poprzedniego layoutu

        try {
            const qualityLevelsObj = JSON.parse(qualityLevels);
            this.MinimumDpi = qualityLevelsObj.MinimalDpi;
            this.OptimalDpi = qualityLevelsObj.OptimalDpi;
        } catch (e) {
            this.MinimumDpi = 150;
            this.OptimalDpi = 300;
            console.error("Error parsing quality levels JSON: ", e);
        }

        if (!this.stage.findOne(`#${TAGS.PRESENTER_LAYER}`)) {
            console.error("Error: presenter not found in the stage.");
            return false;
        }

        const passePartout = this.stage.findOne(`#${TAGS.PASSE_PARTOUT}`);

        if (!passePartout) {
            console.error("Error: passePartout not found in the stage.");
            return false; // corrupted Layout
        }
        passePartout.fill(window.getComputedStyle(document.getElementById(this.domElementUid)).backgroundColor); // przypisanie koloru kontenera

        const bgShadow = this.stage.findOne(".backgroundShadow");

        if (bgShadow) {
            bgShadow.shadowColor(`rgba(0,0,0,${this.isMobile ? 0.20 : 0.25})`);
        }

        this.resizeStage();

        this.prepareItems(); // przygotowanie elementów na nowym layoutcie

        this._initBase(mode);
        this.stage.batchDraw();
        return true; // load zakończony sukcesem 
    }

    /**
     * Funkcja ładująca template ("zpieczony") z jsona - do pobrania i wydrukowania. Zwraca status.
     * @public
     * @param {string} json - zserializowany template (stage)
     * @param {number} dpi
     * @param {number} [overprintX = 0] - wartość overprint w poziomie w mm
     * @param {number} [overprintY = 0] - wartość overprint w pionie w mm
     * @returns {boolean}
     */
    initForDownload(json, dpi, overprintX=0, overprintY=0) {
        Konva.pixelRatio = 1;
        if (this.stage) {
            this.stage.destroy();
        };
        try {
            this.stage = Konva.Node.create(json, this.domElementUid);
        } catch (e) {
            console.log("Error during Konva.Node.create: " + e);
            return false;
        }

        const pageMainBackground = this.stage.findOne(`#${TAGS.PAGE_MAIN_BACKGROUND}`);

        if (!pageMainBackground) {
            console.log("Error: pageMainBackground not found in the stage.");
            return false; // nie udało się znaleźć tła - corupted Layout
        }

        this.mainLayer = this.stage.findOne(`#${TAGS.MAIN_LAYER}`);
        if (!this.mainLayer) {
            console.log("Error: templateLayer not found in the stage.");
            return false; // nie udało się znaleźć layera - corupted Layout
        }
        this.layout = this.mainLayer.findOne(`#${TAGS.LAYOUT}`);
        if (!this.layout) {
            console.log("Error: layout not found in the stage.");
            return false; // corrupted Layout
        }

        this.stage.findOne(`#${TAGS.PRESENTER_LAYER}`).destroy();

        this.pageUnit = this.stage.getAttr("nativePageUnit") || this.pageUnit; // jeśli nie podano to domyślnie 10px/mm
        this.pageWidth = pageMainBackground.width(); //początkowe wartości
        this.pageHeight = pageMainBackground.height();
        this.stage.scale({ x: 1, y: 1 });
        this.pageScale = 1; // resetowanie skali strony, żeby nie było problemów z renderowaniem wielokrotnym
        this.layoutScale = this.layout.scaleX();

        //#region Obsługa overprint
        if (overprintX !== 0 || overprintY !== 0) {
            //sprawdzamy czy layout ma margines od ścianek
            const clientRect = this.layout.getClientRect({ relativeTo: this.mainLayer }); //pobranie obszaru w którym coś jest
            //console.log("ClientRect: ", clientRect);
            //console.log("scale:", this.layout.scaleX());
            //console.log("position:", this.layout.position()); 
            const hasMargin = clientRect.x > 0 && clientRect.y > 0 && clientRect.width <= (this.layout.getAttr("designWidth") * this.layoutScale) && clientRect.height <= (this.layout.getAttr("designHeight") * this.layoutScale);
            const overprint = { x: overprintX * this.pageUnit, y: overprintY * this.pageUnit };

            let newWidth = this.pageWidth + 2 * overprint.x; // powiększenie szerokości o overprint
            let newHeight = this.pageHeight + 2 * overprint.y; // powiększenie wysokości o overprint

            if (hasMargin) { //umieszczenie na większej kartce - o overprint
                this.stage.offsetX(-overprint.x);
                this.stage.offsetY(-overprint.y);

            } else { //powiększenie i fit-in
                const { scale, x, y } = Util.getCentralFitInParams(this.pageWidth, this.pageHeight, newWidth, newHeight);
                this.stage.offsetX(-x / scale);
                this.stage.offsetY(-y / scale);
                this.pageScale = scale; // ustawienie skali na nową wartość
                newWidth = this.pageWidth + 2 * x / scale; // przeskalowanie szerokości
                newHeight = this.pageHeight + 2 * y / scale; // przeskalowanie wysokość
            }

            pageMainBackground.setAttrs({ //powiększenie tła aby obejmowało overprint
                x: this.stage.offsetX(),
                y: this.stage.offsetY(),
                width: newWidth,
                height: newHeight
            });

            this.pageWidth = newWidth; // powiększenie szerokości o overprint
            this.pageHeight = newHeight; // powiększenie wysokości o overprint
        }
        else {
            this.stage.offsetX(0);
            this.stage.offsetY(0);
        }
        //#endregion

        this.pageScale *= ((this.pageWidth * this.pageScale) / (25.4 * this.pageUnit) * dpi) / (this.pageWidth * this.pageScale); //można skrócić do dpi/(25.4 * this.pageUnit)
        this.stage.width(this.pageWidth);
        this.stage.height(this.pageHeight);

        //console.log("width", this.pageWidth, "height:", this.pageHeight, "scale:", this.pageScale);
        this.mainLayer.imageSmoothingEnabled(false);
        this.mainLayer.clip(null); // usunięcie clipu, żeby nie było problemów z renderowaniem - na wszelki wypadek
        //console.log("layoutScale: ", this.layoutScale);

        //#region Usunięcie pustych placeholderów zdjęć i textboxów
        for (const text of this.layout.find(`.${TAGS.TEXTBOX}`)) {
            if (!text.getAttr('definedText'))
                text.getParent().destroy();
        }

        for (const node of this.layout.find(`.${TAGS.IMAGE_PLACEHOLDER}`)) {
            if (!node.getAttr('photoId')) {
                if (node.hasStroke()) {
                    node.setAttrs({
                        name: "shape",
                        fill: node.stroke(), //"transparent"
                        fillPriority: "color"
                    });
                } else {
                    node.getParent().destroy();
                }
            }
        }
        //#endregion

        //this.transformer = new ScaleTransformer();
        this.stage.batchDraw();
        this.minRequestedImagesLongerSide = null; // nie ograniczamy sztucznie wielkości zdjęć
        this.maxRequestedImagesLongerSide = null;
        this.mode = MODE.RENDER;
        this.pixelRatio = 1;
        this.stage.listening(false);
        return true;
    }

    _initBase(mode) {

        /*if (!this.clientSelector) {
            this.clientSelector = new ClientSelector('#4cc9f0', this.relativeValue(4));
        }*/

        if (!this.transformer) {
            this.transformer = new ScaleTransformer();
        }

        this.modeHandler(mode);

        /*this.mainLayer.add(this.transformer);
        // funkcja do zaznaczania/odznaczania i transformacji prostokątami
        this.stage.on('click tap', this.handleClickDesignMode);*/
    }

    /**
     * Funkcja podmienia aktualny layout na nowy. Zwraca status.
     * @private 
     * @param {string} json
     * @param {boolean} keepPhotos - czy mają zostać zachowane zdjęcia z poprzedniego layoutu
     * @param {boolean} [resizable=true] - czy layout ma być skalowany do rozmiaru strony
     * @returns {boolean}
     */
    _loadLayout(json, keepPhotos, resizable=true) {
        //#region 1 - Zdeserializowanie nowego layoutu
        let newLayout;
        try {
            newLayout = Konva.Node.create(json);
        } catch (e) {
            return false; // jeśli nie udało się zdeserializować jsona to zwracamy false
        }
        //#endregion

        //#region 2 - Resize
        if (resizable) {
            const designWidth = newLayout.getAttr("designWidth");
            const designHeight = newLayout.getAttr("designHeight");
            if (this.pageWidth !== designWidth || this.pageHeight !== designHeight) { // jeśli romiar kartki nie jest równu rozmiarowi layoutu
                const clientRect = newLayout.getClientRect({ skipTransform: true }); //pobranie obszaru w którym coś jest
                //console.log("ClientRect: ", clientRect);
                const hasMargin = (clientRect.x > 0 && clientRect.y > 0) && (clientRect.width <= designWidth && clientRect.height <= designHeight);
                const fitingFunction = hasMargin ? Util.getCentralFitInParams : Util.getCentralFitOutParams; // jeśli jest margines robimy fit-in , jeśli nie to fit-out
                const { scale: layoutScale, ...position } = fitingFunction(
                    designWidth,
                    designHeight,
                    this.pageWidth,
                    this.pageHeight
                );
                newLayout.setAttrs({
                    ...position,
                    scaleX: layoutScale,
                    scaleY: layoutScale
                });
            }
        }
        this.layoutScale = newLayout.scaleX(); // dla zachowania działania pxOnScreen
        //#endregion

        // #region 2 - Przeniesienie zdjęć i z-index z poprzedniego layout'u (jeśli był)
        let zIndex; // do przechowania pozycji layoutu - domyślnie undefined
        if (this.layout) {
            if (keepPhotos === true) {
                let photosList = [];
                for (const node of this.layout.find(n => { return n.hasName(TAGS.IMAGE_PLACEHOLDER) && n.getAttr("photoId"); })) {
                    photosList.push(new Photo(node.getAttr('photoId'), node.fillPatternImage(), node.getAttr('crop'), node.getAttr('photoFlip'), node.fillPatternRotation(), this.getAspectRatio(node), node.getAttr('photoFilter')));
                }

                if (photosList.length > 0) {
                    this.TransferPhotos(photosList, newLayout); //przeniesienie zdjęć do nowego template "off-canvas"
                    this.containsLoadedPhotos = true; // jeśli zdjęcia zostały przeniesione, to znaczy, że layout zawiera zdjęcia
                }
                // TODO  dodać filtrowanie na distinct obj

                //przenoszenie attr textbox'ów
                let textboxesList = [];
                for (const text of this.layout.find(n => { return n.hasName(TAGS.TEXTBOX) && n.getAttr("definedText") })) {
                    textboxesList.push(text.getAttr("definedText"));
                }
                if (textboxesList.length > 0) {
                    for (const node of newLayout.find(n => { return n.hasName(TAGS.TEXTBOX) && !n.getAttr("definedText") })) {
                        if (textboxesList.length === 0)
                            break;
                        const newText = textboxesList.shift(); 
                        node.setAttr("definedText", newText); // przypisanie zdefiniowanego tekstu 
                        Util.fitText(node, newText, node.getAttr("defaultFontSize"), this.getMinFontSize());//dopasowanie rozmiaru czcionki do tekstu
                    }
                }
            }
            zIndex = this.layout.zIndex(); // zapamiętanie z-indexu layera - żeby potem wstawić w to samo miejsce na stage
            this.layout.destroy();
        }
        // #endregion

        // #region 3 - Ustawienie nowego layoutu jako aktualnego layout
        this.layout = newLayout;
        this.mainLayer.add(this.layout);

        if (zIndex !== undefined) {
            this.layout.setZIndex(zIndex); // ustawienie z-indexu na taki sam jak był poprzednio
        }
        // #endregion

        //#region 4 - Nadanie placeholderom i textboxom odpowiednich stylów
        this.prepareItems(); // przygotowanie elementów na nowym layerze
        // #endregion
        return true;
    }

    /**
     * Funkcja podmienia aktualny layout na nowy + przypięcie eventów i reload zdjęć - parametry jak w _loadLayout.
     * Zwraca status.
     * @public 
     * @param {...any} prams
     * @returns {boolean}
     */
    changeLayout(...prams) {
        /* Na razie po stronie Dawida
        if (this.requestReloadTimeout !== null) {
            clearTimeout(this.requestReloadTimeout);
        }*/
        const isSuccess = this._loadLayout(...prams);
        if (!isSuccess) {
            console.error("Error changing layout");
            return false;
        }
        this.attachItemsStyleReactions(this.mode); // podpięcie reakcji na styli placeholderów i textboxów
        /*
        if (this.containsLoadedPhotos)
            this.requestReloadTimeout = setTimeout(() => { this.LoadAndResolveAllPhotos() }, 1000);*/
        return true;
    }

    /**
     * Metoda tworząca grupę tła i dodająca ją do mainLayer.
     * @private
     * @param {string} bgColor - kolor tła
     * @param {Uid} bgImageId - id obrazu tła
     */
    loadBackground(bgColor, bgImageId) {
        const currentBg = this.mainLayer.findOne(`#${TAGS.BACKGROUND_GROUP}`);
        if (currentBg)
            currentBg.destroy();

        const backgroundGroup = new Konva.Group({ id: TAGS.BACKGROUND_GROUP });
        const mainBackground = new Konva.Rect({
            x: 0,
            y: 0,
            width: this.pageWidth,
            height: this.pageHeight,
            fill: bgColor || "white",
            name: "background",
            id: TAGS.PAGE_MAIN_BACKGROUND
        });
        backgroundGroup.add(mainBackground);
        this.mainLayer.add(backgroundGroup);

        if (bgImageId) {
            const backgroundImage = mainBackground.clone({
                id: uuidv4(),
                name: "image",
                fillPriority: "pattern",
                initImageId: bgImageId
            });
            backgroundGroup.add(backgroundImage);
        };

        if (this.isMobile)
            mainBackground.preventDefault(false); // jeśli jest to urządzenie mobilne to nie blokujemy domyślnego zachowania

        backgroundGroup.moveToBottom(); // tło powinno być na samym dole, żeby nie zasłaniało layout (current)
    }

    /**
     * Metoda aktualizująca grupę tła.
     * @public
     * @param {string} bgColor - kolor tła
     * @param {Uid} bgImageId - id obrazu tła
     */
    updateBackgroundLayer(bgColor, bgImageId) {
        const currentMainBackground = this.stage.findOne(`#${TAGS.PAGE_MAIN_BACKGROUND}`);
        if (!currentMainBackground)
            return;

        if (bgColor)
            currentMainBackground.fill(bgColor);

        if (bgImageId) {
            const bgImage = currentMainBackground.findOne(".image");
            if (bgImage) {
                bgImage.setAttrs({
                    initImageId: bgImageId
                });
            } else {
                const backgroundImage = currentMainBackground.clone({
                    id: uuidv4(),
                    name: "image",
                    fillPriority: "pattern",
                    initImageId: bgImageId
                });
                currentMainBackground.getGroup().add(backgroundImage);
            }
        }
    }

    /**
     * Funkcja zwrca warstwę prezentera na podstawie typu prezentera lub jsona. Zwraca obiekt zawierający presenterLayer i offset, lub undefined jeśli nie udało się stworzyć prezentera.
     * @private
     * @param {string} presenterType - typ prezentera zgodnie z enumem AddPredefinedPresenters, lub "Custom" jeśli ma być użyty json
     * @param {string} json - json z definicją prezentera, jeśli presenterType to "Custom"
     * @returns {{ presenterLayer: Konva.Layer, offset: {x:number, y:number}, size:{width:number, height:number}}}
     */
    async getPresenterLayer(presenterType, json) {
        if (this.stage) {
            const currentPresenter = this.stage.findOne(`#${TAGS.PRESENTER_LAYER}`);
            if (currentPresenter)
                currentPresenter.destroy();
        }
        let presenterParams;
        const bgColor = window.getComputedStyle(document.getElementById(this.domElementUid)).backgroundColor;
        if (presenterType === "Custom") {
            console.log("Decaprivated!");
            presenterParams = {presenterLayer: Konva.Node.create(json),offset:{x:0,y:0},size:{width:this.pageWidth,height:this.pageHeight}};
        } else {
            presenterParams = await PredefinedPresenters[presenterType](this.pageWidth, this.pageHeight,0, this.isMobile, bgColor);
        }
        if (!presenterParams) {
            return undefined;
        }
        
        return presenterParams;
    }

    /**
     * Metoda przygotowująca elementy w layoutcie - nadanie styli etc.
     */
    prepareItems() {
        const photoPlaceholders = this.layout.find(`.${TAGS.IMAGE_PLACEHOLDER}`);
        this.photoPlaceholdersCount = photoPlaceholders.length;
        for (const node of photoPlaceholders) {
            if (!node.getAttr('photoId')) {
                this.applyPlaceholderEmptyStyle(node); // jeśli nie ma photoId to przypisujemy placeholder
            }

            if (this.isMobile) {
                node.preventDefault(false);
            }
            // czy jest sens dawać fill transparent ? --> w przypadku kiedy do jsona zapisze się z error stylem miało by to sens
        }
        for (const text of this.layout.find(`.${TAGS.TEXTBOX}`)) {
            text.width(text.width()); // konieczne, żeby text się poprawnie zawijał
            text.height(text.height());

            if (this.isMobile) {
                text.preventDefault(false);
            }
            if (text.getAttr('translatable')) continue; // jeśli podlega tłumaczeniu to Dawid się tym zajmie

            if (text.getAttr('definedText')) {
                text.text(text.getAttr('definedText'));
                this.exitTextboxStyle(text);
            } else {
                Util.fitText(text, text.getAttr('customPromptText') || this.defaultPromptText, text.getAttr('defaultFontSize'), this.getMinFontSize());
                this.applyTextboxStyle(text);
            }
        }
    }
    //#endregion

    //#region Loading images
    /**
     * Funkcja ładująca zdjęcie zgodnie z photoId danego elemetu.
     * @public
     * @param {Konva.Shape} item
     * @param {boolean} fitImageInItem true - ma zostać wykonane skalowanie i centrowanie zdjęcia, false - zdjęcie ma zostać po prostu wstawione
     * @param {boolean} reloadOnlyWhenUrlChanged jeśli true to zdjęcie będzie ładowane TYLKO jeśli zmienił się url, false - zdjęcie będzie zawsze ładowane
     * @param {boolean} [checkPhotoQuality = false] jeśli true to zdjęcie będzie sprawdzane pod kątem jakości, jeśli nie to nie będzie sprawdzane
     * @param {{width:number, height:number}} [minPhotoSize = null] minimalny rozmiar zdjęcia do wczytania (opcjonalnie - można podać jeśli ma się już wyliczony)
     * @returns {Promise<void>}
     */
    async LoadPhoto(item, fitImageInItem, reloadOnlyWhenUrlChanged, checkPhotoQuality = false, minPhotoSizePreCal = null) {
        // 1 - wyliczenie rozmiarów potrzebnego zdjęcia 
        const minPhotoSize = minPhotoSizePreCal || this.calculateRequiredImageSize(item);

        const photoId = item.getAttr('photoId');
        // 2 - otrzymanie url'a i maksymalnych rozmiarów zdjęcia
        const photoParams = await this.getPhoto(photoId, minPhotoSize);

        // 3 - jeśli nie jest wymuszone ładowanie zdjęcia to sprawdzamy czy url się zmienił - jeśli nie to nie ładujemy zdjęcia
        if (!this.shouldReloadPhoto(item.fillPatternImage(), minPhotoSize) && reloadOnlyWhenUrlChanged && item.fillPatternImage().getAttribute('src') === photoParams.Url) { // nie ładujemy ponownie jeśli url nie uległ zmianie i nie ma konieczności ładowania większego zdjęcia
            //console.log("Not loading");
            return; // jeśli zdjęcie jest już wczytane to nie trzeba go wczytywać ponownie
        }

        //console.log("Loading photo: " + photoParams.Url); 
        // 6 - ładowanie zdjęcia i nakładanie filtrów
        const loadTask = () => new Promise((resolve, reject) => {
            var img = new Image();
            img.crossOrigin = "Anonymous";
            img.onload = () => {

                this.containsLoadedPhotos = true; // jeśli zdjęcie się załadowało to znaczy że layout zawiera zdjęcia
                //console.log("img:", img.width, "x", img.height);
                //console.log("img natural:", img.naturalWidth, "x", img.naturalHeight);

                //#region Utworzenie fillPattern Canvas
                const canvas = document.createElement('canvas');
                let scale = Math.max(minPhotoSize.width / img.naturalWidth, minPhotoSize.height / img.naturalHeight);
                //console.log("scale: ", scale);
                canvas.maxAvailableImageWidth = photoParams.MaxAvailableImageWidth;
                canvas.maxAvailableImageHeight = photoParams.MaxAvailableImageHeight;

                //canvas.src = img.src;
                canvas.setAttribute('src', photoParams.Url);

                // Pobierz kontekst 2D
                const ctx = canvas.getContext('2d');
                if (scale < 1 && this.mode !== MODE.RENDER) {
                    canvas.width = Math.round(img.naturalWidth * scale);
                    canvas.height = Math.round(img.naturalHeight * scale);
                } else {
                    canvas.width = img.naturalWidth;
                    canvas.height = img.naturalHeight;
                }
                if (this.mode !== MODE.RENDER) {
                    ctx.imageSmoothingEnabled = true;
                    ctx.imageSmoothingQuality = 'medium';
                } else {
                    ctx.imageSmoothingEnabled = false; // w trybie render nie ma wygładzania
                }

                //console.log("canvas:", canvas.width, "x", canvas.height);

                if (this.contextFilterAvailable)
                    ctx.filter = item.getAttr('photoFilter') || ''; //to trzeba stosować przed rysowaniem

                // Narysuj obrazek na canvasie 
                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                // Zastosowanie filtru

                if (!this.contextFilterAvailable)
                    CustomFilters.applyFilter(ctx, item.getAttr('photoFilter')); // to trzeba stosować dopiero po wyrysowaniu
                //#endregion

                const destItem = item.getAttr('photoId') === photoId ? item : this.layout.findOne((n) => {
                    return n.hasName(TAGS.IMAGE_PLACEHOLDER) && n.getAttr('photoId') === photoId;
                });

                if (destItem) {
                    this.exitPlaceholderStyle(destItem);
                    destItem.fillPatternImage(canvas); // ustawienie fillPatternImage na canvas z wczytanym zdjęciem

                    if (fitImageInItem) {
                        KonvaCropper.applyCrop(destItem);
                    }

                    if (checkPhotoQuality) {
                        this.checkPhotoQualityLevel(destItem);
                    }
                }

                this.abortHandlers.delete(onAbort);
                this.mainLayer.batchDraw();
                resolve();
            };
            img.onerror = (error) => {
                console.log(error);

                const destItem = item.getAttr('photoId') === photoId ? item : this.layout.findOne((n) => {
                    return n.hasName(TAGS.IMAGE_PLACEHOLDER) && n.getAttr('photoId') === photoId;
                });

                if (destItem) {
                    destItem.fillPatternImage(null); // --> upewniamy się że nie zostałuy pozostałości po wcześniejszych wczytaniach
                    this.clearPhotoCropAndSettings(destItem);
                    this.applyPlaceholderErrorStyle(destItem);
                }

                this.abortHandlers.delete(onAbort);
                resolve();
            }

            // Funkcja anulowania dla tej instancji loadImage
            const onAbort = () => {
                console.log("Aborted image loading: " + img.src);
                img.src = ''; // Czyści źródło obrazu, co powoduje przerwanie wczytywania
                reject(); // potencjalni porządany efekt --> Promise.all się przerwie
            };

            // Dodaj funkcję anulowania do zestawu
            this.abortHandlers.add(onAbort);

            img.src = photoParams.Url;
        });

        return KonvaComponentPhotoLoadQueue.add(loadTask);
    }

    /**
     * Funkcja ładująca obraz zgodnie z initImageId danego elemetu typu Konva.Image
     * @public
     * @param {Konva.Image} item
     * @returns {Promise<void>}
     */
    async LoadResource(item) {
        const url = await this.getResourceUrl(item.getAttr('initImageId'));

        return new Promise((resolve) => {
            var img = new Image();
            img.crossOrigin = "Anonymous";
            img.onload = () => {
                console.log("Onload");
                console.log(img.src);
                item.setAttrs({
                    image: img
                });
                this.abortHandlers.delete(onAbort);
                this.mainLayer.batchDraw();
                resolve();
            };
            img.onerror = () => {
                console.log("Onerror");
                //img.src = "_content/PixelTech.Konva/image/onerror.png"; // --> to wywołuje znowu onload
                this.abortHandlers.delete(onAbort);
                resolve();
            }

            // Funkcja anulowania dla tej instancji loadImage
            const onAbort = () => {
                console.log("Aborted image loading: " + img.src);
                img.src = ''; // Czyści źródło obrazu, co powoduje przerwanie wczytywania
                reject();
            };

            // Dodaj funkcję anulowania do zestawu
            this.abortHandlers.add(onAbort);


            img.src = url;
        });
    }

    /**
     * Metoda inicjalizująca ładowanie wszystkich zasobów.
     * @public
     */
    LoadAndResolveAllResources(notifyDotNet = false) {
        //console.log("LoadAndResolveAllResources");  
        if (notifyDotNet && this.dotNetReference)
            this.dotNetReference.invokeMethodAsync("LoadingResources", true);
        const loadingProgress = [];
        for (const node of this.stage.find(`.${TAGS.IMAGE_RESOURCE}`)) {
            if (node.getAttr('photoId')) {
                loadingProgress.push(this.LoadPhoto(node, true, true, false));
            }
            else if (node.getAttr('initImageId')) {
                loadingProgress.push(this.LoadResource(node));
            }
        }

        Promise.all(loadingProgress).then(() => {
            if (this.dotNetReference) {
                this.dotNetReference.invokeMethodAsync("LoadingResources", false);
            }
        });
    }

    /**
     * Metoda inicjalizująca ładowanie wszystkich zdjęć.
     * @public
     * @param {boolean} [notifyDotNet = false] - czy dotNet ma być informowany o rozpoczęciu/zakończeniu ładowania
     * @param {boolean} [checkPhotosQualityLevels = false] - czy ma być sprawdzany poziom jakości zdjęć (czy są wystarczająco dobre do wydruku)
     */
    LoadAndResolveAllPhotos(notifyDotNet = false, checkPhotosQualityLevels = false) {
        if (notifyDotNet && this.dotNetReference)
            this.dotNetReference.invokeMethodAsync("LoadingPhotos", true);

        const loadingProgress = [];
        for (const node of this.mainLayer.find(n => { return n.hasName(TAGS.IMAGE_PLACEHOLDER) && n.getAttr("photoId"); })) {
            loadingProgress.push(this.LoadPhoto(node, true, true, checkPhotosQualityLevels));
        }

        // Zmienione z Promise.allSettled ponieważ nie potrzebujemy informacji zwrotnej które zdjęcia nie udało się załadować
        Promise.all(loadingProgress).then(() => {
            if (notifyDotNet && this.dotNetReference) {
                this.dotNetReference.invokeMethodAsync("LoadingPhotos", false);
            }
        });
    }
    //#endregion

    //#region Initializing placeholder's photoId
    /**
     * Funkcja przepisuje zdjęcia z listy do placeholderów (taki inner load w trybie reset). Wykorzystywać przy zmianie layoutów do przenoszenia zdjęć między nimi.
     * @param {Array<Photo>} photosList lista obiektów opisującyh zdjęcia
     */
    TransferPhotos(photosList, destLayout) {
        if (photosList instanceof Array === false) return; // zabezpieczenie przed przekazaniem błędnego typu obiektu

        for (const node of destLayout.find(`.${TAGS.IMAGE_PLACEHOLDER}`)) {
            let photoIdIndex = node.getAttr('pictureNo') - 1;
            if (photoIdIndex < photosList.length && photoIdIndex >= 0) {
                node.setAttrs({
                    photoId: photosList[photoIdIndex].photoId,
                    fillPatternImage: photosList[photoIdIndex].photoHtmlImage,
                    fillPatternRotation: photosList[photoIdIndex].rotation,
                    photoFlip: photosList[photoIdIndex].flip,
                    crop: photosList[photoIdIndex].crop,
                    photoFilter: photosList[photoIdIndex].filter
                });
                this.exitPlaceholderStyle(node);
                KonvaCropper.calculateNewPseudoCrop(node, photosList[photoIdIndex].originalAspectRatio);
                KonvaCropper.applyCrop(node);
                this.checkPhotoQualityLevel(node);
                // this.ajustPhotoResolution(node); ???
                // czy podczas transferu coś może pójść nie tak, i powinno być obsłużone np. photoId ale photoHtmlImage === null /undefined ? --> to samo dotyczy shuffle
            }
        }
    }

    /**
     * Funkcja przypisuje photoId z listy do pustych placeholder'ów (appended) i zwraca ilość wykożystanych zdjęć
     * @param {string} json - lista identyfikatorów zdjęć (po deserializacji)
     * @param {number} offset - wskazuje na pierwsze zdjęcie z listy które ma być brane pod uwagę
     * @param {number} startItem - wskazuje na placeholder od którego ma się zacząć przypisywanie zdjęć
     * @returns {number} - zwraca ilość użytych zdjęć z listy
     */
    LoadJsonPhotoPackage(json, offset, startItemId) {
        const photoIdList = JSON.parse(json);
        if (photoIdList instanceof Array === false) return 0; // zabezpieczenie przed przekazaniem błędnego typu obiektu
        let currentPhotoIdIndex = offset - 1;
        let lastPicatureNo = 0;
        const placeholdersList = this.mainLayer.find('.image_placeholder').sort((a, b) => a.getAttr('pictureNo') - b.getAttr('pictureNo')); // posortowane rosnąco po pictureNo
        const startItemIndex = (startItemId ? placeholdersList.findIndex(item => item.id() === startItemId) : 0);
        let i = startItemIndex;
        // implementacja cykliczna 
        do {
            const node = placeholdersList[i];

            if (!node.getAttr('photoId')) { // jeśli już ma przypisane zdjęcie to nie zmieniamy
                if (node.getAttr('pictureNo') !== lastPicatureNo) {
                    if (++currentPhotoIdIndex < photoIdList.length) { // powiększenie currentPhotoIdIndex i sprawdzenie czy mieści się w zakresie
                        lastPicatureNo = node.getAttr('pictureNo');
                    } else {
                        currentPhotoIdIndex--; // cofnięcie inkrementacji z if'a
                        break;
                    }
                }
                node.setAttrs({
                    photoId: photoIdList[currentPhotoIdIndex]
                });
                console.log(node);
            }
            i = (i + 1) % placeholdersList.length; // przejście do następnego elementu w liście - cyklicznie
        } while (i !== startItemIndex); // dopóki nie wrócimy do elementu startowego
        return currentPhotoIdIndex - offset + 1; // zwraca ilość użytych zdjęć z listy
    }
    //#endregion

    //#region Metody dodające elementy do layoutu

    addRectangle(x, y, w, h, picatureNo,borderRadius) {
        const rect = new Konva.Rect({
            id: uuidv4(),
            friendlyName: 'Rectangle',
            x: x * this.pageUnit,
            y: y * this.pageUnit,
            width: w * this.pageUnit,
            height: h * this.pageUnit,
            fill: 'gray',
            name: 'shape',
            draggable: false,
            pictureNo: picatureNo || 1
        });
        if (borderRadius && borderRadius > 0) {
            rect.cornerRadius(borderRadius*this.pageUnit);
        }
        this.layout.add(rect);
    }
    addCircle(xpos, ypos, width, height) {
        const circle = new Konva.Ellipse({
            id: uuidv4(),
            friendlyName: 'Circle',
            radiusX: width * this.pageUnit / 2 || this.pxOnScreen(100),
            radiusY: height * this.pageUnit / 2 || this.pxOnScreen(100),
            fill: 'pink',
            name: 'shape',
            draggable: false,
        });
        circle.offset({ x: -circle.radiusX(), y: -circle.radiusY() });
        circle.position({
            x: xpos * this.pageUnit || 0,
            y: ypos * this.pageUnit || 0
        });
        this.layout.add(circle);
    }
    addCustomShape(svgD, svgFillRule, preservePosition = false, preservedPositionOffsetX = 0, preservedPositionOffsetY = 0) {
        var svgBase = Util.scaleSvgPath(svgD, this.pageUnit);
        var path = new Konva.Path({
            id: uuidv4(),
            friendlyName: 'CustomShape',
            x: 0,
            y: 0,
            name: "shape",
            data: svgBase,
            fill: "green",
            fillRule: svgFillRule || "nonzero" // domyślnie nonzero
        });
        path.width(path.getClientRect().width);
        path.height(path.getClientRect().height);
        const svgOffset = { x: path.getClientRect().x, y: path.getClientRect().y };
        path.offset(svgOffset);
        //path.scale({ x: svgScale || 1, y: svgScale || 1 }); // skalowanie do jednostek strony
        if (preservePosition)
            path.position({
                x: svgOffset.x/**svgScale*/ + preservedPositionOffsetX * this.pageUnit,
                y: svgOffset.y/**svgScale*/ + preservedPositionOffsetY * this.pageUnit
            });
        this.layout.add(path);
    }
    addPolygon(pointsList, xpos = 0, ypos = 0) {
        const points = pointsList.split(/[\s,]+/).map(point => parseFloat(point.trim()) * this.pageUnit).filter(n => !isNaN(n)); // przeskalowanie punktów do jednostek strony
        const polygon = new Konva.Line({
            id: uuidv4(),
            x: xpos * this.pageUnit,
            y: ypos * this.pageUnit,
            points: points,
            friendlyName: 'CustomShape',
            fill: 'red',
            closed: true,
            name: 'shape',
            draggable: false
        });
        this.layout.add(polygon);
    }
    async addClipart(resurceId) {
        const img = new Image();
        img.onload = () => {
            const clipArt = new Konva.Image({
                id: uuidv4(),
                friendlyName: 'Clipart',
                x: 0,
                y: 0,
                width: 100,
                height: 100,
                image: img,
                initImageId: resurceId,
                name: 'image',
                draggable: false,
            });
            //this.mainLayer.getContext()._context.imageSmoothingEnabled = true; // włączenie wygładzania obrazów
            //this.mainLayer.getContext()._context.imageSmoothingQuality = 'high'; // ustawienie jakości wygładzania obrazów
            this.layout.add(clipArt);
        }
        img.src = "images/layoutDemo/DSCF2260.JPG";
    }
    addTextBox(x,y,width,height) {
        // tworzenie tekstu już jako textbox'a (odpowiednik placeholdera)
        const textboxGroup = new Konva.Group({ name: 'textboxGroup', x: x*this.pageUnit ?? 0, y:y*this.pageUnit ?? 0 });
        const text = new Konva.Text({
            id: uuidv4(),
            name: 'textbox',
            friendlyName: 'Text',
            padding: this.standardUnits(1),
            text: this.defaultPromptText,
            ellipsis: true,
            draggable: false,
            align: 'center',
            verticalAlign: 'middle',
            fontFamily: 'NunitoRegular',
            definedText: "",
            customPromptText: "",
            translatable: false,
        });
        if (width && height) {
            text.setAttrs({
                fontSize: (height * this.pageUnit) - text.padding()*2,
                defaultFontSize: (height * this.pageUnit) - text.padding() * 2,
                width: width * this.pageUnit,
                height: height * this.pageUnit,
            });
        } else {
            text.setAttrs({
                fontSize: this.standardUnits(5), // 10 - bardzo duża, 5 - mała/średnia, 3 - mała/bazowa
                defaultFontSize: this.standardUnits(5),
            });
        }

        textboxGroup.add(text);
        this.layout.add(textboxGroup);
        this.applyTextboxStyle(text);
    }
    //#endregion
    setToBePlaceholder() {
        // Zamiast const selectedItem = this.transformer.nodes()[0] ?? null;
        var selectedItem = (this.transformer.nodes().length > 0) ? this.transformer.nodes()[0] : null;
        if (selectedItem) {

            const placeholderGroup = new Konva.Group({ // okomentować w przyszłości
                name: 'placeholderGroup',
                x: selectedItem.x(),
                y: selectedItem.y(),
                rotation: selectedItem.rotation()
            });

            selectedItem.setAttrs({
                x: 0,
                y: 0,
                rotation: 0, // lokalnie
                fill: 'rgb(153,153,153,0.67)',
                name: 'image_placeholder',
                fillPriority: 'pattern',
                fillPatternRepeat: 'no-repeat',
                photoId: null,
                photoFlip: 1,
                photoFilter: ' '
            });
            this.layout.add(placeholderGroup);
            placeholderGroup.add(selectedItem);

            this.applyPlaceholderEmptyStyle(selectedItem);
        }
    }
    deleteSelectedItem() {
        // Zamiast const selectedItem = this.transformer.nodes()[0] ?? null;
        var selectedItem = (this.transformer.nodes().length > 0) ? this.transformer.nodes()[0] : null;
        if (selectedItem) {
            this.transformer.diselectItem();
            selectedItem.destroy();
        }
    }
    //#region Alert Badges
    /**
     * Bazowa metoda dodawania Alert Badge do elementu
     * @param {Konva.Shape} item
     * @param {string} color
     * @param {string} message
     * @param {boolean} enableEvents
     */
    _baseAddAlertBadge(item, color, message, tag, enableEvents) {
        if (item.hasAlertBadge) {
            const alertBadge = item.getParent().findOne('.alert_badge');
            if (alertBadge.hasName(tag))
                return;
            else
                alertBadge.destroy();
        } else
            item.hasAlertBadge = true;

        const margin = this.pxOnScreen(10);
        const size = this.pxOnScreen(20);
        const strokeOffset = Util.getStrokeOffset(item);
        const alertBadge = new AlertBadge(message, size, tag, {
            x: (item.width() - strokeOffset / 2) * item.scaleX() - size - margin,
            y: (strokeOffset / 2) * item.scaleY() + margin,
            fill: color
        }
        );

        item.getParent().add(alertBadge);

        if (enableEvents)
            alertBadge.initTween();
        else
            alertBadge.listening(false);
    }
    refreshAlertBadge(alertBadge) {
        const margin = this.pxOnScreen(10);
        const size = this.pxOnScreen(20);
        alertBadge.size = size;
        const item = alertBadge.getParent().findOne(`.${TAGS.IMAGE_PLACEHOLDER}`);
        const strokeOffset = Util.getStrokeOffset(item);
        alertBadge.setAttrs({
            x: (item.width() - strokeOffset / 2) * item.scaleX() - size - margin,
            y: (strokeOffset / 2) * item.scaleY() + margin
        });
    }
    addLowQualityAlertBadge(item) {
        this._baseAddAlertBadge(item, "#FF0000", this.lowQualityMessage, 'lowQuality', !this.isMobile); // dodanie alert badge z komunikatem o niskiej jakości
    }
    addMidQualityAlertBadge(item) {
        this._baseAddAlertBadge(item, "#ffa500", this.mediumQualityMessage, "midiumQuality", !this.isMobile); // dodanie alert badge z komunikatem o średniej jakości
    }
    removeAlertBadge(item) {
        const alertBadge = item.getParent().findOne('.alert_badge');
        if (alertBadge) {
            alertBadge.destroy();
            item.hasAlertBadge = false; // ustawienie flagi, że jest alert badge
        }
    }
    //#endregion
    
    //#region Placeholder styling methods
    async _baseAddIcon(item, iconName, iconFileName, iconSize, iconVisibility) {
        this.ICONS_REPOSITORY.getIconFromRepo(iconFileName).then((img) => {
            let innerImage = item.getParent().findOne(`.${iconName}`);
            if (!innerImage)
                innerImage = new Konva.Image({ image: img, name: iconName, listening: false });
            else
                innerImage.setAttrs({
                    image: img,
                    width: img.width,
                    height: img.height
                });
            innerImage.visible(iconVisibility);
            Util.centerImageOnItem(item, innerImage, iconSize);
            item.getParent().add(innerImage);
        }).catch((e) => { });
    }
    /**
     * Metoda nadająca placeholderowi styl pustego miejsca na zdjęcie
     * @param {Konva.Shape} item
     */
    applyPlaceholderEmptyStyle(item) {
       // item.fill("#E1E1E1"); //#F2F2F2 - oryginal
        Util.apply2StepLinearGradient(item,-this.layout.y()/this.layoutScale,(this.pageHeight-this.layout.y())/this.layoutScale, "#ececec", "#d8d8d8");
        const iconSize = this.standardUnits(13) * (this.photoPlaceholdersCount === 1 ? 2 : 1);
        this._baseAddIcon(item, TAGS.BASE_ICON, "AddImage.svg", iconSize , true);
        if (!this.isMobile && this.mode !== MODE.PREVIEW)
            this._baseAddIcon(item, TAGS.ACTIVE_ICON, "AddImageActive.svg", iconSize, false);
    }

    applyPlaceholderErrorStyle(item) {
        item.fill("#f7e1ce");
        item.fillPriority("color");
        const iconSize = this.standardUnits(13) * (this.photoPlaceholdersCount === 1 ? 2 : 1);
        this._baseAddIcon(item, TAGS.BASE_ICON, "corruptedFileIcon.svg", iconSize, true);
        if (!this.isMobile && this.mode !== MODE.PREVIEW)
            this._baseAddIcon(item, TAGS.ACTIVE_ICON, "corruptedFileActiveIcon.svg", iconSize, false);
    }
    removePlaceholdersIcons(item) {
        const baseIcon = item.getParent().findOne(`.${TAGS.BASE_ICON}`);
        if (baseIcon) {
            baseIcon.destroy();
        }
        if (!this.isMobile) {
            const activeIcon = item.getParent().findOne(`.${TAGS.ACTIVE_ICON}`);
            if (activeIcon) {
                activeIcon.destroy();
            }
        }
    }
    exitPlaceholderStyle(item) {
        this.removePlaceholdersIcons(item);
        item.setAttrs({
            fill: "transparent",
            fillPriority: "pattern",
            fillLinearGradientStartPoint: null, //czyszczenie prametrów gradientu żeby się nie zapisywał do jsona
            fillLinearGradientEndPoint: null,
            fillLinearGradientColorStops: null
        });
        item.fill('transparent');
        item.fillPriority("pattern");
    }

    onMouseOverPlaceholderStyleReaction(event) {
        document.body.style.cursor = 'pointer';
        if (this.fillPatternImage()) {
            //#region dodanie rozjaśnienia
            const dummyClone = Util.getDummyClone(this);
            dummyClone.fill('white'); // zmiana koloru na niebieski
            dummyClone.opacity(0.07);
            this.getParent().add(dummyClone);
            if (this.hasAlertBadge)
                dummyClone.moveDown(); //jeśli jest alertbadge to ustawiamy dymmyclone za nim
            //#endregion
        } else {
            const activeIcon = this.getParent().findOne(`.${TAGS.ACTIVE_ICON}`);
            if (activeIcon) {
                activeIcon.visible(true);
                const baseIcon = this.getParent().findOne(`.${TAGS.BASE_ICON}`);
                if (baseIcon) {
                    baseIcon.visible(false);
                }
            }
        }
    }
    onMouseOutPlaceholderStyleReaction(event) {
        document.body.style.cursor = 'default';
        if (this.fillPatternImage()) {
            this.getParent().findOne('.dummyClone').destroy(); // usunięcie dummyClone - rozjaśnienia

        } else {
            const activeIcon = this.getParent().findOne(`.${TAGS.ACTIVE_ICON}`);
            if (activeIcon) {
                activeIcon.visible(false);
                const baseIcon = this.getParent().findOne(`.${TAGS.BASE_ICON}`);
                if (baseIcon) {
                    baseIcon.visible(true);
                }
            }
        }
    }
    //#endregion

    //#region Textbox styling methods
    applyTextboxStyle(item) {
        item.opacity(1);
        const textboxGroup = item.getParent();
        textboxGroup.opacity(0.27);
        const borderRect = textboxGroup.findOne('Rect') || new Konva.Rect();
        borderRect.setAttrs({
            x: 0,
            y: 0,
            width: item.width(),
            height: item.height(),
            fill: 'transparent',
            stroke: 'black',
            strokeWidth: this.standardUnits(0.25),
            dash: [this.standardUnits(1.1), this.standardUnits(1.1)],
            listening: false, // nie przechwytuje zdarzeń - za zdarzenia odpowiada textbox - grupa służy jak w przypadku placeholdera tylko celom dekoracyjnym
            cornerRadius: this.standardUnits(0.4),
            draggable: false
        });

        textboxGroup.add(borderRect);
        borderRect.moveToBottom();
    }
    exitTextboxStyle(item) {
        item.getParent().opacity(1);
        const borderRect = item.getParent().findOne('Rect');
        if (borderRect) {
            borderRect.destroy();
        }
    }
    onMouseOverTextboxStyleReaction(event) {
        document.body.style.cursor = 'pointer';
        if (this.getAttr('definedText')) {
            this.opacity(0.7);
        } else {
            this.getParent().opacity(0.99);
            const borderRect = this.getParent().findOne('Rect');
            this.fill('#35a0d7');
            if (borderRect) {
                borderRect.stroke('#35a0d7');
            }
        }
    }
    onMouseOutTextboxStyleReaction(event) {
        document.body.style.cursor = 'default';
        if (this.getAttr('definedText')) {
            this.opacity(1);
        } else {
            this.getParent().opacity(0.27);
            const borderRect = this.getParent().findOne('Rect');
            this.fill(this.getAttr('textColor') || 'black');
            if (borderRect) {
                borderRect.stroke('black');
            }
        }
    }

    //#endregion

    //#region Funkcje pomocnicze
    /**
     * Returns a relative value scaled to the page scale.
     * @param {number} x - The value can be an integer or a float.
     */
    pxOnScreen(x, ignoreLayoutScale = false) {
        return (x / this.pageScale) / (ignoreLayoutScale ? 1 : this.layoutScale); // deskalowanie
    }
    /**
     * Funkcja zwraca artość będącą zadaną ilośćcią jednostek standardowych
     * @param {number} coutOfUnits
     * @returns {number}
     */
    standardUnits(coutOfUnits, ignoreLayoutScale = false) {
        return (coutOfUnits * (((this.pageHeight + this.pageWidth) / 2) / 100)) / (ignoreLayoutScale ? 1 : this.layoutScale);
    }

    /**
     * Zwraca proporcje obiektu zaokrąglone od 13 pozycji po przecinku w celu uniknięcia błędów wynikających z dokładności skali
     * @param {Konva.Shape} item
     */
    getAspectRatio(item) {
        return Math.round(((item.width() * item.scaleX()) / (item.height() * item.scaleY()) * 1e13)) / 1e13;
    }
    getSizeInPx(item) {
        const strokeOffset = Util.getStrokeOffset(item);
        const absoluteScale = item.getAbsoluteScale(); // jeśli render to nie ma znaczenia skala strony, bo jest już przeskalowane do px na ekranie)
        if (this.mode === MODE.RENDER) {
            absoluteScale.x *= this.pageScale / this.stage.scaleX(); // w trybie renderowania pageScale jest ustawiane wirtualnie 
            absoluteScale.y *= this.pageScale / this.stage.scaleY();
        }
        return {
            width: (item.width() - strokeOffset) * absoluteScale.x,
            height: (item.height() - strokeOffset) * absoluteScale.y
        };
    }
    getSizeInMM(item, ignoreLayoutScale = false) {
        const strokeOffset = Util.getStrokeOffset(item);
        const scale = (ignoreLayoutScale ? 1 : this.layoutScale) / this.pageUnit;
        return {
            width: (item.width() - strokeOffset) * item.scaleX() * scale,
            height: (item.height() - strokeOffset) * item.scaleY() * scale
        };
    }
    getMinFontSize() {
        return 3 * this.pageUnit * this.layoutScale; // 3 mm
    } 
    /**
     * Funkcja czyści wszytskie ustawienia użytkownika związa ze zdjęciem - kadr, obrót, flip, filtry
     * @param {Konva.Shape} item
     */
    clearPhotoCropAndSettings(item) {
        item.setAttrs({
            fillPatternRotation: 0,
            photoFlip: 1,
            crop: null,
            photoFilter: ' '
        });
    }
    /**
     * Funkcja wylicza minimalne wymagane rozmiary zdjęcia na podstawie wymiarów placeholder i skali fillPattern
     * @param {Konva.Shape} item
     * @returns {{width: number, height: number}} obiekt z wymiarami
     */
    calculateRequiredImageSize(item) {
        const crop = item.getAttr('crop');
        let cropWidth = 1, cropHeight = 1;

        if (crop) {
            cropWidth = crop.width || 1;
            cropHeight = crop.height || 1;
        }
        const itemSize = this.getSizeInPx(item);

        let minImageWidth = itemSize.width / cropWidth;
        let minImageHeight = itemSize.height / cropHeight;

        minImageWidth *= this.pixelRatio || 1; // jeśli nie ma to domyślnie 1
        minImageHeight *= this.pixelRatio || 1; // jeśli nie ma to domyślnie 1

        let longerSide = Math.max(minImageWidth, minImageHeight);
        //let scaleFactor = 1;

        // ucięcie do przedziału
        /*if (this.minRequestedImagesLongerSide && longerSide < this.minRequestedImagesLongerSide) {
           scaleFactor =  this.minRequestedImagesLongerSide / longerSide;
        }
        else*/

        if (this.maxRequestedImagesLongerSide && longerSide > this.maxRequestedImagesLongerSide) {
            let scaleFactor = this.maxRequestedImagesLongerSide / longerSide;
            minImageWidth *= scaleFactor;
            minImageHeight *= scaleFactor;
        }

        if (item.fillPatternRotation() % 180 !== 0) // jeśli kąt nie jest równy 0 lub 180 to zamień szerokość z wysokością
            [minImageWidth, minImageHeight] = [minImageHeight, minImageWidth];

        return {
            width: Math.floor(minImageWidth),
            height: Math.floor(minImageHeight)
        };
    }
    /**
    * Metoda sprawdza czy jakość załadowanego zdjęcia jest odpowiednia względem całkowitego powiększenia na ekranie.
    * Jeśli okaże się że jest za mała metoda oblicza minimlną potrzebną rozdzielczość i wywołyje asynchronicznie (bez czekania na rezultat) ponowne ładowanie zdjęcia.
    * UWAGA - podany item musi mieć fillPatternImage !!
    * @param {HTMLImageElement} image załadowane zdjęcie z atrybutami maxAvailableImageWidth i maxAvailableImageHeight
    * @param {{width: number, height: number}} calculatedMinRequiredPhotoSize obiekt z wyliczonymi minimalnymi wymiarami
    * @returns {boolean} true - należy załadować większe zdjęcie, false - aktualnie załadowano już największe dostępne zdjęcie lub większe nie jest potrzedne
    */
    shouldReloadPhoto(image, calculatedMinRequiredPhotoSize) {
        if (!image) return true; // jeśli nie ma zdjęcia to trzeba zrobić reload

        return calculatedMinRequiredPhotoSize && ( // sprawdzenie czy istnieje obiekt
            calculatedMinRequiredPhotoSize.width > image.width || // sprawdzenie czy większe jest potrzebne
            calculatedMinRequiredPhotoSize.height > image.height) &&
            image.width < image.maxAvailableImageWidth && // sprawdzenie czy większe zdjęcie jest dostępne
            image.height < image.maxAvailableImageHeight;
    }

    checkPhotoQualityLevel(item) {
        const crop = item.getAttr('crop');
        let cropW = crop && crop.width;
        const photo = item.fillPatternImage();
        let photoWidth = (item.fillPatternRotation() % 180 === 0) ? photo.maxAvailableImageWidth : photo.maxAvailableImageHeight;
        if (!cropW) {
            const photoAspectRatio = photoWidth / ((item.fillPatternRotation() % 180 === 0) ? photo.maxAvailableImageHeight : photo.maxAvailableImageWidth);
            const placeholderAspectRatio = this.getAspectRatio(item);
            cropW = placeholderAspectRatio >= photoAspectRatio ? 1 : placeholderAspectRatio / photoAspectRatio; // zabezpieczenie przed dzieleniem przez zero
            //console.log("Crop width is not set, using default value: " + cropW);
        }

        const placeholderTmp = this.getSizeInMM(item).width / 25.4;

        if (cropW * photoWidth >= this.OptimalDpi * placeholderTmp) {
            if (item.hasAlertBadge)
                this.removeAlertBadge(item);
            return;
        } else if (cropW * photoWidth < this.MinimumDpi * placeholderTmp) {
            this.addLowQualityAlertBadge(item);
        } else { // this.MinimumDpi * placeholderTmp < cropW * photoWidth < this.Optimal * placeholderTmp
            this.addMidQualityAlertBadge(item);
        }

    }
    checkAllPhotosQualityLevel() {
        for (const node of this.mainLayer.find(n => { return n.hasName(TAGS.IMAGE_PLACEHOLDER) && n.getAttr('photoId') && n.fillPatternImage(); })) {
            this.checkPhotoQualityLevel(node);
        }
    }
    createNewStage(config) {
        this.stage = new Konva.Stage({
            container: this.domElementUid,
            nativePageUnit: this.pageUnit,
            ...config
        });
    }
    createNewMainLayer() {
        this.mainLayer = new Konva.Layer({
            id: TAGS.MAIN_LAYER,
            imageSmoothingEnabled: false
            //imageSmoothingQuality: "medium"
        });
    }
    //#endregion

    download(fileName, dpi /*ignoreUnloadedImages*/, mimeType, watermarkText) {
        const destWidth = this.pageWidth / (25.4 * this.pageUnit) * dpi;
        const ratio = this.pageScale;//destWidth / this.pageWidth;
        console.log("pageScale: ", this.pageScale);
        for (const node of this.mainLayer.find('.image_placeholder')) { //sprawdzenie czy wszystkie zdjęcia się załadowały 
            if (!node.fillPatternImage()) {
                return false; // jeśli nie ignorować --> zgłosić że nie można pobrać layout'u
            }
        }

        for (const node of this.mainLayer.find('.image')) { //sprawdzenie czy wszystkie resoursy się załadowały 
            if (!node.image()) {
                return false; // jeśli nie ignorować --> zgłosić że nie można pobrać layout'u
            }
        }

        let enrolledMimeType;
        if (mimeType === "JPEG") {
            enrolledMimeType = "image/jpeg";
        } else if (mimeType === "PNG") {
            enrolledMimeType = "image/png";
        } else {
            console.log("Error: Unsupported mimeType");
            return false;
        }

        if (watermarkText) {
            // #region generate watermark
            const watermark = new Konva.Text({
                text: watermarkText,
                fill: '#878787',
                opacity: 0.5,
                fontStyle: 'bold',
                fontSize: this.standardUnits(6.9),
                padding: this.standardUnits(3),
                lineHeight: 2,
            });
            var watermarkImage = watermark.toCanvas();
            watermark.destroy();
            const watermarkRect = new Konva.Rect({
                id: 'watermarkRect',
                width: this.pageWidth,
                height: this.pageHeight,
                fillPatternImage: watermarkImage,
                fillPatternOffsetY: this.standardUnits(3.45),
                fillPatternRepeat: 'repeat',
                fillPriority: 'pattern'
            });
            this.mainLayer.add(watermarkRect);
            // #endregion
        }
        try {

            var dataUrl = this.stage.toDataURL({
                pixelRatio: ratio,
                mimeType: enrolledMimeType,
                quality: 1,
                imageSmoothingEnabled: false,
            });

            var link = document.createElement('a');
            link.download = fileName;
            link.href = dataUrl;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            link = null;

        } catch (e) {
            console.log("Error during download: " + e);
            return false;
        }

        return true;
    }
    saveToJson() {
        this.selectedItem = null;

        // Wyłączenie manipulatorów
        let temp;
        if (this.mode === "Design") { // zastąpić czymś lepszym w przyszłości !!!!!!!!!
            this.transformer && this.transformer.diselectItem();
            temp = this.transformer;
            temp.remove(); // usunięcie z layera
        }

        let alertBadgesList = [];
        for (const alertBadge of this.mainLayer.find(`.${TAGS.ALTER_BADGE}`)) {
            const placeholder = alertBadge.getParent().findOne(`.${TAGS.IMAGE_PLACEHOLDER}`);
            this.removeAlertBadge(placeholder); // // usunięcie z layera / można rozważyć remove ale nie wiem co będzie bardziej obciążające
            alertBadgesList.push(placeholder.id()); //zapisanie od komu trzeba potem przywrócić badge
        }

        const json = this.stage.toJSON();

        if (temp)
            this.mainLayer.add(temp);
        // przywrócenie alert badge
        for (const placeholderId of alertBadgesList) {
            const placeholder = this.mainLayer.findOne(`#${placeholderId}`);
            if (placeholder) {
                this.checkPhotoQualityLevel(placeholder);
            }
        }

        return json;
    }
    generatePhotoLayoutPackage() {

        for (const node of this.mainLayer.find(`.${TAGS.IMAGE_PLACEHOLDER}`)) {
            this.removePlaceholdersIcons(node);
        }
        for (const text of this.mainLayer.find(`.${TAGS.TEXTBOX}`)) {
            const border = text.getParent().findOne("Rect");
            border.destroy();
        }

        let temp;
        if (this.mode === MODE.DESIGN) { // zastąpić czymś lepszym w przyszłości !!!!!!!!!
            this.transformer && this.transformer.diselectItem();
            temp = this.transformer;
            temp.remove(); // usunięcie z layera
        }

        const layoutJson = this.layout.toJSON();

        if (temp)
            this.mainLayer.add(temp);

        const bgColor = this.mainLayer.findOne(`#${TAGS.PAGE_MAIN_BACKGROUND}`).fill();

        const presenterType = this.stage.findOne(`#${TAGS.PRESENTER_LAYER}`).getAttr("presenterType");
        const presenterJson = presenterType === "Custom"
            ? this.stage.findOne(`#${TAGS.PRESENTER_LAYER}`).toJSON()
            : null;
        const tmp =
        {
            Size: { Width: this.pageWidth / this.pageUnit, Height: this.pageHeight / this.pageUnit },
            QualityLevels: { OptimalDpi: this.OptimalDpi, MinimalDpi: this.MinimumDpi },
            PresenterType: presenterType,
            PresenterCustomJson: presenterJson,
            LayoutJson: layoutJson,
            BackgroundImageId: null,
            BackgroundColor: bgColor,
            Resizable: true
        };
        return JSON.stringify(tmp);
    }
    /**
     * @override 
     */
    resizeStage() {
        if (!this.stage || window.globalSupressResize) return;
        if (this.containsLoadedPhotos && this.requestReloadTimeout !== null) {
            clearTimeout(this.requestReloadTimeout);
        }
        const oldScale = this.pageScale;
        super.resizeStage(); // wywołanie metody bazowej resizeStage
        this.pixelRatio = window.devicePixelRatio || 1; // jeśli nie ma to domyślnie 1
        if (this.layout)
            this.layout.find(`.${TAGS.ALTER_BADGE}`).forEach(badge => this.refreshAlertBadge(badge));
        if (this.containsLoadedPhotos && oldScale ) {
            this.requestReloadTimeout = setTimeout(() => { this.LoadAndResolveAllPhotos(); }, 1000);
        }
    }

    //#region Conversion to C# objects
    /**
     * Funkcja konwertuje element Konva na obiekt zgodny z PageItem 
     * @param {Konva.Node} item
     */
    convertToPageItem(item) {
        return { Id: item.id(), FriendlyName: item.getAttr('friendlyName') }
    }
    /**
     * Funkcja konwertuje element Konva na obiekt zgodny z PhotoItem 
     * UWAGA : używać tylko na obiektach które posiadają id, pictureNo, photoId, width i height !!
     * @param {Konva.Shape} item
     * @returns object deseralizable to PhotoItem
     */
    convertToPhotoItem(item) {
        const crop = item.getAttr('crop');
        const itemSize = this.getSizeInMM(item);
        return {
            Id: item.id(),
            FriendlyName: item.getAttr('friendlyName'),
            PictureNo: item.getAttr('pictureNo'),
            WidthMM: itemSize.width,
            HeightMM: itemSize.height,
            PhotoId: item.fillPatternImage() ? item.getAttr('photoId') : undefined,
            PhotoRotation: Math.abs(item.fillPatternRotation()),
            PhotoFlip: item.getAttr('photoFlip'),
            PhotoFilter: item.getAttr('photoFilter'),
            ...(crop ? {
                CropX: crop.x,
                CropY: crop.y,
                CropWidth: crop.width,
                CropHeight: crop.height
            } : {})

        }
    }

    /**
     * Funkcja konwertuje element typu Konva.Tekst na obiekt o prototypie zgodny z TextItem
     * UWAGA : używać tylko na obiektach Konva.Text
     * @param {Konva.Text} item
     * @returns object deseralizable to TextItem
     */
    convertToTextItem(item) {
        if (item.getClassName() !== 'Text') return;
        return {
            Id: item.id(),
            FriendlyName: item.getAttr('friendlyName'),
            FontFamily: item.fontFamily(),
            FontSize: item.getAttr('definedFontSize') || item.fontSize(),
            TextColor: item.getAttr('textColor') || 'black',
            Text: item.getAttr('definedText'),
            CustomPromptText: item.getAttr('customPromptText'),
            Translatable: item.getAttr('translatable')
        }
    }
    /**
     * Funkcja składa parametry do postaci obiektu zgodnego z prototypem UrlResolveRequestParams
     * @param {Guid} imageId
     * @param {{width:number, height:number}} minImageSize
     * @returns object deseralizable to UrlResolveRequestParams
     */
    convertToUrlResolveRequestParams(imageId, minImageSize) {
        return {
            ImageId: imageId,
            minImageWidth: minImageSize.width,
            minImageHeight: minImageSize.height
        }
    }
    //#endregion

    //#region Komunikacja z C#
    getImagePlaceholdersList() {
        let imagePlaceholders = [];
        for (const node of this.mainLayer.find('.image_placeholder')) {
            imagePlaceholders.push(this.convertToPhotoItem(node));
        }
        return JSON.stringify(imagePlaceholders);
    }

    getTextboxesList() {
        let textboxes = [];
        for (const node of this.mainLayer.find('.textbox')) {
            textboxes.push(this.convertToTextItem(node));
        }
        return JSON.stringify(textboxes);
    }

    getDistinctPhotoIdsList() {
        let photoIds = [];
        for (const node of this.mainLayer.find('.image_placeholder')) {
            if (node.getAttr('photoId')) {
                photoIds.push(node.getAttr('photoId'));
            }
        }
        photoIds = photoIds.filter((value, index, self) => self.indexOf(value) === index);
        return photoIds;
    }
    getLayoutStatusReport() {
        let report = {
            EmptyPlaceholders: 0,
            NotLoadedPhotos: 0,
            NotLoadedResources: 0,
            EmptyTextboxes: 0,
        };

        //#region Przegląd placeholder'ów
        for (const node of this.mainLayer.find('.image_placeholder')) {
            if (node.getAttr('photoId') && node.fillPatternImage()) { // poprawnie załadowane zdjęcie
                continue;
            }
            else if (node.getAttr('photoId') && !node.fillPatternImage()) {
                report.NotLoadedPhotos++;
            }
            else if (!node.getAttr('photoId')) {
                report.EmptyPlaceholders++;
            }
        }
        //#endregion

        //#region Przegląd resources'ów
        for (const node of this.stage.find('.image')) {
            if (!node.fillPatternImage()) {
                if (node.getAttr('photoId')) {
                    report.NotLoadedPhotos++;
                }
                else if (node.getAttr('initImageId')) {
                    report.NotLoadedResources++;
                }
            }
        }
        //#endregion

        //#region Przegląd textbox'ów
        for (const text of this.mainLayer.find(n => { return n.hasName(TAGS.TEXTBOX) && !n.getAttr('definedText') })) {
            report.EmptyTextboxes++;
        }
        //#endregion

        return JSON.stringify(report);
    }
    /**
     * Funkcja wysyła informację o zaznaczonym elemencie
     * @param {Konva.Node} item
     */
    sendItemSelected(item) {
        if (this.dotNetReference) {
            let itemType = item.name();
            let itemJsonData;
            switch (itemType) {
                case "image_placeholder":
                    {
                        itemJsonData = JSON.stringify(this.convertToPhotoItem(item));
                        break;
                    }
                case "textbox":
                    {
                        itemJsonData = JSON.stringify(this.convertToTextItem(item));
                        break;
                    }
            }
            console.log("Sending item selection: ", itemType, itemJsonData);
            this.dotNetReference.invokeMethodAsync("ItemSelectionHandler", itemType, itemJsonData);
        }
    }

    /**
     * Funkcja wysyła informację że wszystkie elementy zostały odznaczone
     */
    sendItemsDeselected() {
        if (this.dotNetReference) {
            this.dotNetReference.invokeMethodAsync("ItemSelectionHandler", "", null);
        }
    }
    /**
     * Funkcja zwraca adres url zdjęcia o podanym id i jego maksymnalną rozdielczość
     * @param {string} photoId 
     * @param {{width:number, height:number}} minImageSize minimalna rozdzielczość zdjęcia - domyślnie null - brak wymagań 
     * @returns {{Url: string, MaxAvailableImageWidth:number, MaxAvailableImageHeight:number}} - adres url zdjęcia i maksymalna osiągalną wielkość
     */
    async getPhoto(photoId, minImageSize) {
        if (!photoId) throw new Error("Can't ask to resolve url when photoId is null");
        //const urlResolveRequestParams = JSON.stringify(this.convertToUrlResolveRequestParams(photoId, minImageSize));
        let urlResolveResposeParams = await this.dotNetReference.invokeMethodAsync("UrlResorver", photoId, minImageSize.width, minImageSize.height);
        /* try {
             urlResolveResposeParams = JSON.parse(urlResolveResposeParams);
         } catch (e) {
             console.error("Error parsing JSON response: ", e);
         }*/
        return JSON.parse(urlResolveResposeParams);
    }

    async getResourceUrl(resourceId) {
        return await this.dotNetReference.invokeMethodAsync("ResourceUrlResorver", resourceId);
    }
    /**
     * Funkcja aktualizująca zdjęcie w elemencie image_placeholder o id podanym w jsonUpdateParams  
     * @param {string} jsonUpdateParams
     */
    updateImagePhotoId(jsonUpdateParams) {
        let newParams = JSON.parse(jsonUpdateParams);
        //console.log("New params: ", newParams);
        const targetItem = this.stage.findOne('#' + newParams.Id);
        /*targetItem.setAttrs({
            pictureNo: newParams.PictureNo,
            scaleX: newParams.WidthMM * this.pageUnit / targetItem.width(),
            scaleY: newParams.HeightMM * this.pageUnit / targetItem.height(),
        });*/
        let newRequiredPhotoSize = null;
        let hasPhotoChanged = false;
        let hasCropSizeChanged = false;
        let hasRotationChanged = false;

        if (newParams.PhotoId) {
            hasPhotoChanged = targetItem.getAttr('photoId') !== newParams.PhotoId; // sprawdzenie czy photoId się zmieniło
            hasRotationChanged = targetItem.fillPatternRotation() !== (newParams.PhotoRotation * newParams.PhotoFlip); // sprawdzenie czy rotacja się zmieniła

            targetItem.setAttrs({
                fillPatternRotation: newParams.PhotoRotation * newParams.PhotoFlip,
                photoFlip: newParams.PhotoFlip
            });

            const cropRound = 4; // zaokrąglenie do 4 miejsc po przecinku
            const currentCrop = targetItem.getAttr('crop');
            hasCropSizeChanged = !(currentCrop && Util.equalsInRound(currentCrop.width, newParams.CropWidth, cropRound) && Util.equalsInRound(currentCrop.height, newParams.CropHeight, cropRound));

            if (hasCropSizeChanged
                || !Util.equalsInRound(currentCrop.x, newParams.CropX, cropRound)// w zaokrągleniu do 4 miejsc po przecinku
                || !Util.equalsInRound(currentCrop.y, newParams.CropY, cropRound)) { // nastąpiła zmiana kadru

                targetItem.setAttrs({
                    crop: {
                        x: newParams.CropX,
                        y: newParams.CropY,
                        width: newParams.CropWidth,
                        height: newParams.CropHeight
                    }
                });

                KonvaCropper.setCropCenterPoint(targetItem);
                newRequiredPhotoSize = this.calculateRequiredImageSize(targetItem); // przeliczenie minimalnych wymagań dla zdjęcia
            }

            if (targetItem.fillPatternImage()) // placeholder posiada wczytane zdjęcie OD RAZU stosujemy crop - na użądzeniach mobilnych długo trwa doładowanie
            {
                KonvaCropper.applyCrop(targetItem);
            }

            if (hasPhotoChanged // jeśli zmieniło się photoId --> nowe zdjęcie 
                || targetItem.getAttr('photoFilter').trim() !== newParams.PhotoFilter // jeśli zmienił się filtr
                || this.shouldReloadPhoto(targetItem.fillPatternImage(), newRequiredPhotoSize)) // jeśli jest zapotrzebowanie na większe zdjęcie
            {
                targetItem.setAttrs({
                    photoId: newParams.PhotoId,
                    photoFilter: newParams.PhotoFilter
                });

                this.LoadPhoto(targetItem, true, false, (hasRotationChanged || hasCropSizeChanged || hasPhotoChanged), newRequiredPhotoSize); // przeładuj - z awaitem ?
            }
            else if (targetItem.fillPatternImage() && (hasRotationChanged || hasCropSizeChanged)) // w przypadku zmiany rotacji/powiększenia trzeba sprawdzić czy zdjęcie jest odpowiedniej jakości
            {
                this.checkPhotoQualityLevel(targetItem);
            }

        } else {
            // back to be empty placeholder
            targetItem.setAttrs({
                photoId: null,
                fillPatternImage: null
            });
            this.clearPhotoCropAndSettings(targetItem); // czyszczenie ustawień i kadru poprzedniego zdjęcia - nie zostawiamy śmieci
            if (node.hasAlertBadge)
                this.removeAlertBadge(targetItem); // usunięcie alert badge (jeśli była)
            this.applyPlaceholderEmptyStyle(targetItem);
        }

    }
    //#region Designer Func's
    updateItemDesignMode(x, y, w, h, picatueNo, borderWidth, borderColor = "white") {
        var nodes = this.transformer.nodes();
        var targetItem = (nodes.length > 0) ? nodes[0] : null;
        if (!targetItem) return;
        const currentStrokeoffset = Util.getStrokeOffset(targetItem); // domyślnie 0
        if (targetItem.getClassName() !== 'Rect') {
            targetItem.setAttrs({
                x: x !== null ? (x * this.pageUnit - currentStrokeoffset / 2) : targetItem.x(),
                y: y !== null ? (y * this.pageUnit - currentStrokeoffset / 2) : targetItem.y(),
                pictureNo: picatueNo || targetItem.getAttr('pictureNo'),
                scaleX: w ? (w * this.pageUnit / targetItem.width()) : targetItem.scaleX(),
                scaleY: h ? (h * this.pageUnit / targetItem.height()) : targetItem.scaleY(),
            });
        } else {
            targetItem.setAttrs({
                x: x !== null ? (x * this.pageUnit - currentStrokeoffset / 2) : targetItem.x(),
                y: y !== null ? (y * this.pageUnit - currentStrokeoffset / 2) : targetItem.y(),
                pictureNo: picatueNo || targetItem.getAttr('pictureNo'),
                scaleX: w ? 1 : targetItem.scaleX(),
                scaleY: h ? 1 : targetItem.scaleY(),
                width: w ? (w * this.pageUnit) : targetItem.width(),
                height: h ? (h * this.pageUnit) : targetItem.height(),
            });
        }

        if (borderWidth !== null && borderWidth >= 0 && borderWidth !== targetItem.strokeWidth()) {
            targetItem.stroke(borderColor); // ustawienie koloru obramowania
            const nW = (targetItem.width() - currentStrokeoffset) * targetItem.scaleX() + (borderWidth * this.pageUnit);
            const nH = (targetItem.height() - currentStrokeoffset) * targetItem.scaleY() + (borderWidth * this.pageUnit);
            targetItem.scale({
                x: nW / targetItem.width(),
                y: nH / targetItem.height(),
            })
            targetItem.position({
                x: targetItem.x() + currentStrokeoffset / 2 - (borderWidth * this.pageUnit) / 2,
                y: targetItem.y() + currentStrokeoffset / 2 - (borderWidth * this.pageUnit) / 2,
            }); // zakładamy proporcjonalne skalowanie
            targetItem.strokeWidth((borderWidth * this.pageUnit) / targetItem.scaleX()); // zakładamy proporcjonalne skalowanie
        }
    }
    updateTextItemDesignMode(x, y, w, h, fontSize, fontFamily) {
        var nodes = this.transformer.nodes();
        var targetItem = (nodes.length > 0) ? nodes[0] : null;
        if (!targetItem || !targetItem.hasName("textboxGroup")) return;
        targetItem.setAttrs({
            x: x !== null ? (x * this.pageUnit) : targetItem.x(),
            y: y !== null ? (y * this.pageUnit) : targetItem.y(),
        });
        const text = targetItem.findOne('Text');
        const border = targetItem.findOne('Rect');
        if (fontSize !== null && fontSize > 0) {
            text.setAttrs({
                fontSize: fontSize * this.pageUnit,
                defaultFontSize: fontSize * this.pageUnit // zapamiętanie wielkości czcionki
            });
        }

        if (w !== null && w > 0) {
            text.width(w * this.pageUnit);
            if (border) {
                border.width(text.width()); // ustawienie szerokości borderu
            }
        }
        if (h !== null && h > 0) {
            text.height(h * this.pageUnit);
            if (border) {
                border.height(text.height()); // ustawienie wysokości borderu
            }
        }
        if (fontFamily) {
            text.fontFamily(fontFamily);
        }
    }
    //#endregion

    /**
     * Funkcja aktualizująca tekst w elemencie textbox o id podanym w jsonUpdateParams
     * @param {string} jsonUpdateParams
     */
    updateText(jsonUpdateParams) { // problem ze środkowaniem tekstu
        let newParams = JSON.parse(jsonUpdateParams);
        const targetItem = this.stage.findOne('#' + newParams.Id);
        targetItem.setAttrs({
            fontFamily: newParams.FontFamily,
            definedFontSize: newParams.FontSize,
            //fill: newParams.TextColor,
            textColor: newParams.TextColor,
            definedText: newParams.Text,
            customPromptText: newParams.CustomPromptText,
            translatable: newParams.Translatable
        });

        if (!targetItem.getAttr('defaultFontSize')) {
            targetItem.setAttrs({ defaultFontSize: targetItem.fontSize() }); // zapamiętanie domyślnej wielkości czcionki
        }

        if (newParams.Text) {
            Util.fitText(targetItem, newParams.Text, newParams.FontSize, this.getMinFontSize()); // dopasowanie tekstu do rozmiaru textboxa
            this.exitTextboxStyle(targetItem);
        }
        else {
            Util.fitText(targetItem, newParams.CustomPromptText || this.defaultPromptText, targetItem.getAttr('defaultFontSize'), this.getMinFontSize());
            this.applyTextboxStyle(targetItem);
        }
    }
    //#endregion
    shufflePlaceholdersPhotoIds() {
        if (this.requestReloadTimeout !== null) {
            clearTimeout(this.requestReloadTimeout);
        }

        // krok 1 - pobranie photoId i img z palceholderów - nawet pustych --> lista całkowita
        const photosList = [];
        const placeholdersList = this.mainLayer.find(`.${TAGS.IMAGE_PLACEHOLDER}`);
        for (const node of placeholdersList) {
            photosList.push(new Photo(node.getAttr('photoId'), node.fillPatternImage(), node.getAttr('crop'), node.getAttr('photoFlip'), node.fillPatternRotation(), this.getAspectRatio(node), node.getAttr('photoFilter')));
        }

        if (photosList.length === 0) return; // nic do zmiany :)
        let maxLoopCount = 4; // zabezpieczenie przed nieskończoną pętlą
        do {
            // krok 2 - zastosowanie algorytm tasowania Fisher-Yates na tablicy
            // Przechodzimy od końca tablicy do początku.
            for (let i = photosList.length - 1; i > 0; i--) {

                // Wylosuj indeks z przedziału od 0 do i (włącz) --> tylko z nieprzetworzonej części tablicy.
                const randomIndex = Math.floor(Math.random() * (i + 1));

                // Zamiana elementów, tym samym ustalamy ostatecznie wartość na pozycji i.
                [photosList[i], photosList[randomIndex]] = [photosList[randomIndex], photosList[i]];
            }
            maxLoopCount--;
        } while (maxLoopCount > 0 && !placeholdersList.some((item, index) => { return item.getAttr("photoId") !== photosList[index].photoId; }))


        // krok 3 - przypisanie nowych photoId, img i ustawień zdjęcia do placeholderów
        for (let i = 0; i < photosList.length; i++) {
            const node = placeholdersList[i];
            const newPhoto = photosList[i];

            if (!newPhoto.photoId) {
                if (node.getAttr('photoId')) { // --> z wypełnionego na pusty
                    node.setAttrs({
                        photoId: null,
                        fillPatternImage: null
                    });
                    this.clearPhotoCropAndSettings(node); // czyszczenie ustawień i kadru poprzedniego zdjęcia - nie zostawiamy śmieci :)
                    this.applyPlaceholderEmptyStyle(node); // staje się pustym placeholderem
                    if (node.hasAlertBadge) // jeśli był alert to go usuwamy
                        this.removeAlertBadge(node);
                } else {
                    continue; // nic do zmiany --> z pustego na pusty
                }

            } else {

                if (!node.getAttr('photoId')) { // --> z pustego na wypełniony
                    this.exitPlaceholderStyle(node);
                }
                // else --> z wypełnionego na wypełniony
                node.setAttrs({
                    photoId: newPhoto.photoId,
                    fillPatternImage: newPhoto.photoHtmlImage,
                    crop: newPhoto.crop, // na początku zakładamy nie przenoszenie kadru - by defult ------------------------------
                    fillPatternRotation: newPhoto.rotation,     //                                                                 |
                    photoFlip: newPhoto.flip,
                    photoFilter: newPhoto.filter
                });                                                             //                                                  |
                // ale jeśli wcześniejszy i docelowy placeholder mają te same proporcje to można zastosować kadr    <----------------
                if (newPhoto.originalAspectRatio !== this.getAspectRatio(node)) {
                    KonvaCropper.calculateNewPseudoCrop(node, newPhoto.originalAspectRatio);
                }
                KonvaCropper.applyCrop(node); // dopasowanie zdjęcia do nowego placeholdera
                // czy dopasowywać rozdzielczość zdjęcia do nowego placeholdera ???
                this.checkPhotoQualityLevel(node);
            }
        }
        this.requestReloadTimeout = setTimeout(() => { this.LoadAndResolveAllPhotos() }, 1000);
    } 
}